import React, {useContext, useEffect, useState} from 'react'
import {Button, Divider} from "antd";
import {Table} from "react-bootstrap";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import IngredientsRow from "./IngredientsRow";
import {getAllStock} from "../../../../../services/serviceStock";

const IngredientsContainer = () => {

    const [stockList, setStockList] = useState([])
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    useEffect(() => {
        getAllStock()
            .then(({data}) => {
                handleStockData(data)
            })
    }, [])

    const handleStockData = (list) => {
        let sorted = list.map(item => ({text: `${item.code} - ${item.name}`, value: item.id}))
        setStockList(sorted)
    }

    const handleNewRow = () => {
        let mockRows = Object.assign({}, recipeById)
        const obj = {parity: 1, amount: 1}
        mockRows.billOfMaterials.push(obj)
        setRecipeById(mockRows)
    }

    return(
        <React.Fragment>
            <h3>Malzeme Listesi</h3>
            <Divider />
            <Button
                type={'link'}
                style={{marginBottom: '16px'}}
                onClick={handleNewRow}
            >
                Yeni Ekle
            </Button>
            <Table
                className={'recipe-table'}
                responsive
            >
                <thead>
                    <tr>
                        <th>#</th>
                        <th colSpan={4}>Stok Adı</th>
                        <th>Miktar</th>
                        <th>Birimi</th>
                        <th>Birim Fiyatı</th>
                        <th>Para Birimi</th>
                        <th>Parite</th>
                        <th>Toplam</th>
                    </tr>
                </thead>
                <tbody>
                {
                    recipeById.billOfMaterials.map((item,index) => {
                        return <IngredientsRow key={index} id={index} row={item} stocks={stockList}/>
                    })
                }
                </tbody>
            </Table>
        </React.Fragment>
    )
}
export default IngredientsContainer